import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { useEffect, useState } from "react";
import TipoServicoAcolhimentoService from "../../../../../../main/services/TipoServicoAcolhimentoService";

export const CaracterizacaoServicoAba = ({ children, props }) => {
  const [regimes, setRegimes] = useState({ options: [], isLoading: false });
  const [modalidades, setModalidades] = useState({
    options: [],
    isLoading: false,
  });

  useEffect(() => {
    if (props?.values?.regime) {
      setModalidades((prevState) => ({ ...prevState, isLoading: true }));

      const SAF = (props?.values?.regime || [])
        ?.flat()
        ?.find((item) => item?.id === "SAF");
      const SAI = (props?.values?.regime || [])
        ?.flat()
        ?.find((item) => item?.id === "SAI");

      if (SAF || SAI) {
        TipoServicoAcolhimentoService.pesquisarModalidades(
          SAI?.id || SAF?.id,
        ).then((res) => {
          const tempData = res.data.map((modalidade, index) => {
            return { descricao: modalidade, id: index };
          });

          setModalidades({ options: tempData, isLoading: false });
        });
      } else {
        setModalidades({ options: [], isLoading: false });
      }
    } else {
      setModalidades({ options: [], isLoading: false });
    }
  }, [props?.values?.regime]);

  const handleGetRegimes = () => {
    setRegimes({ ...regimes, isLoading: true });
    TipoServicoAcolhimentoService.pesquisarTipoServicoAcolhimento(
      "",
      "ativos",
      "",
    ).then((res) => {
      const tempRegimes = res.data.map((tsa) => tsa.regime);
      let tempRegimesFinal = [];
      if (tempRegimes.find((regime) => regime === "SAI")) {
        tempRegimesFinal = ["SAI"];
      }
      if (tempRegimes.find((regime) => regime === "SAF")) {
        tempRegimesFinal = [...tempRegimesFinal, "SAF"];
      }
      if (tempRegimesFinal?.length === 2) {
        tempRegimesFinal = ["SAF", "SAI"];
      }
      const tempData = tempRegimesFinal.map((regime) => {
        if (regime === "SAI") {
          return {
            descricao: "Serviço de Acolhimento Institucional",
            id: regime,
          };
        } else {
          return {
            descricao: "Serviço de Acolhimento Familiar",
            id: regime,
          };
        }
      });

      setRegimes({ options: tempData, isLoading: false });
    });
  };

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
          mb={4}
        >
          Caracterização do Serviço de Acolhimento
        </Text>
        {children}
      </Flex>
      <Grid templateColumns="repeat(9, 1fr)" gap="15px" mt="15px" w="100%">
        <GridItem colSpan={{ base: 9, lg: 4, xl: 3 }}>
          <CustomMultiSelectWField
            fieldName="naturezaServico"
            label="Natureza do Serviço"
            placeholder="Selecione a Natureza do Serviço"
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            options={[
              { descricao: "Privada", id: "privada" },
              { descricao: "Pública", id: "publica" },
            ]}
            onChange={(value) => {
              props.setFieldValue("naturezaServico", value);
            }}
            values={props?.values?.naturezaServico[0] || ""}
            visible
            todos
          />
        </GridItem>

        <GridItem colSpan={{ base: 9, lg: 4, xl: 3 }}>
          <CustomMultiSelectWField
            fieldName="regime"
            label={`Regime`}
            placeholder="Selecione o Regime"
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={regimes.isLoading}
            options={regimes.options}
            onChange={(value) => {
              const SAF = value?.flat()?.some((item) => item.id === "SAF");
              const SAI = value?.flat()?.some((item) => item.id === "SAI");

              props.setFieldValue("regime", value);
              props.setFieldValue(
                "modalidade",
                SAF && !SAI ? [[{ descricao: "Não se aplica", id: 0 }]] : "",
              );
            }}
            values={props?.values?.regime[0] || ""}
            onFocus={regimes?.options?.length === 0 ? handleGetRegimes : null}
            visible
            todos
          />
        </GridItem>
        <GridItem colSpan={{ base: 9, lg: 4, xl: 3 }}>
          <CustomMultiSelectWField
            fieldName="modalidade"
            label="Modalidade"
            placeholder="Selecione a Modalidade"
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={modalidades.isLoading}
            options={modalidades.options}
            isDisabled={
              props?.values?.regime &&
              props?.values?.regime
                ?.flat()
                ?.some((item) => item.id === "SAF") &&
              !props?.values?.regime?.flat()?.some((item) => item.id === "SAI")
            }
            onChange={(value) => {
              props.setFieldValue("modalidade", value);
            }}
            values={props?.values?.modalidade[0] || ""}
            visible
            todos
          />
        </GridItem>
      </Grid>
    </>
  );
};
